import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import DeliveryStaffProtectedRoute from './components/DeliveryStaffProtectedRoute';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import DashboardPage from './pages/DashboardPage';
import ProductsPage from './pages/ProductsPage';
import SalesPage from './pages/SalesPage';
import ShopProfilePage from './pages/ShopProfilePage';
import SettingsPage from './pages/SettingsPage';
import OrdersPage from './pages/OrdersPage';
import AdsPage from './pages/AdsPage';
import AiPage from './pages/AiPage';
import TopUpPage from './pages/TopUpPage';
import NotificationsHelpPage from './pages/NotificationsHelpPage';
import TransactionsPage from './pages/TransactionsPage';
import DeliveryStaffPage from './pages/DeliveryStaffPage';
import DeliveryStaffLogin from './pages/DeliveryStaffLogin';
import DeliveryStaffOrders from './pages/DeliveryStaffOrders';
import DeliveryStaffNotificationsHelp from './pages/DeliveryStaffNotificationsHelp';
import OpenOrderAlert from './pages/OpenOrderAlert';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/admin-login" element={<AdminLoginPage />} />
      <Route path="/delivery-staff/login" element={<DeliveryStaffLogin />} />
      <Route path="/open-order-alert" element={<OpenOrderAlert />} />
      <Route
        path="/delivery-staff/orders"
        element={
          <DeliveryStaffProtectedRoute>
            <DeliveryStaffOrders />
          </DeliveryStaffProtectedRoute>
        }
      />
      <Route
        path="/delivery-staff/notifications-help"
        element={
          <DeliveryStaffProtectedRoute>
            <DeliveryStaffNotificationsHelp />
          </DeliveryStaffProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <ProductsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications-help"
        element={
          <ProtectedRoute>
            <NotificationsHelpPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/delivery-staff"
        element={
          <ProtectedRoute>
            <DeliveryStaffPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ads"
        element={
          <ProtectedRoute>
            <AdsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai"
        element={
          <ProtectedRoute>
            <AiPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sales"
        element={
          <ProtectedRoute>
            <SalesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/shop"
        element={
          <ProtectedRoute>
            <ShopProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/topup"
        element={
          <ProtectedRoute>
            <TopUpPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions"
        element={
          <ProtectedRoute>
            <TransactionsPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/orders" replace />} />
      <Route path="*" element={<Navigate to="/orders" replace />} />
    </Routes>
  );
}
